/** Formats a date (epoch ms number or ISO string) as a locale date. Returns empty string for falsy input. */
export function formatLocaleDate(d: number | string | undefined | null): string {
  return d != null && d !== '' ? new Date(d).toLocaleDateString() : '';
}

/** Formats an epoch ms timestamp as a localized GMT date/time string. */
export function formatStatusDate(epochMs: number): string {
  return new Date(epochMs).toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit', second: '2-digit',
    timeZone: 'GMT', timeZoneName: 'short',
  });
}

/** Formats a YYYY-MM-DD ISO date string as a localized UTC date string. */
export function formatUtcDate(isoDate: string): string {
  return new Date(isoDate + 'T00:00:00Z').toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
  });
}

/** Converts an epoch ms timestamp to a YYYY-MM-DD string in UTC. */
export function toIsoDateUtc(epochMs: number): string {
  const d = new Date(epochMs);
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${d.getUTCFullYear()}-${mm}-${dd}`;
}

/** Returns the first day of the current month as a YYYY-MM-DD string in UTC. */
export function getFirstDayOfMonthUtc(): string {
  const d = new Date();
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), 1)).toISOString().substring(0, 10);
}

/** Returns the last day of the current month as a YYYY-MM-DD string in UTC. */
export function getLastDayOfMonthUtc(): string {
  const d = new Date();
  return new Date(Date.UTC(d.getFullYear(), d.getMonth() + 1, 0)).toISOString().substring(0, 10);
}

/** Shifts startDate by delta months and returns the first and last day of that month as YYYY-MM-DD strings. */
export function shiftMonthUtc(isoDate: string, delta: number): { startDate: string; endDate: string } {
  const d = new Date(isoDate + 'T00:00:00Z');
  d.setUTCMonth(d.getUTCMonth() + delta);
  const startDate = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)).toISOString().substring(0, 10);
  const endDate = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).toISOString().substring(0, 10);
  return { startDate, endDate };
}
